export const PATHS = {
	creatorIndex: '/'
};
